import IMAGES from './images'

// region Website config
export const VIEW_MODE = {
  PREVIEW: 'PREVIEW',
  PUBLIC: 'PUBLIC',
}
export const MAIN_SIDEBAR_EXTEND_WIDTH = 256
export const MAIN_SIDEBAR_COLLAPSE_WIDTH = 64
export const MAIN_SIDEBAR_DRAWER_WIDTH = 256
export const MAIN_HEADER_HEIGHT = 64
export const APP_NAME = 'validus'
export const LONG_DATE = 'DD-MM-YYYY HH:mm'
export const REQUEST_BUILDER = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE',
}
export const PAGES = {
  LOGIN: {
    PATH: '/dangnhapkhoahoc',
    NAME: 'login',
  },
  REGISTER_SME: {
    PATH: '/dangky',
    NAME: 'register-sme',
  },
  REGISTER_PREVIEW_SME: {
    PATH: '/xemtruocdangky',
    NAME: 'register-preview-sme',
  },
  REGISTER_COURSE: {
    PATH: '/dangkykhoahoc',
    NAME: 'register-course',
  },
  REGISTER_COURSE_STEP3: {
    PATH: '/thongtindangky',
    NAME: 'register-info',
  },
  REGISTER_SUCCESS: {
    PATH: '/dangkythanhcong',
    NAME: 'register-success',
  },
  I18N: {
    PATH: '/i18n',
    NAME: 'i18n',
  },

  ABOUT_US: {
    PATH: '/about-us',
    NAME: 'about-us',
  },
  TEST: {
    PATH: '/test',
    NAME: 'test',
  },
  HOME: {
    PATH: '/',
    NAME: 'home',
  },
  PREVIEW: {
    PATH: '/xemtruoc',
    NAME: 'preview',
  },
  COURSE_LIST: {
    PATH: '/course-list',
    NAME: 'courses',
  },
  COURSE_DETAIL: {
    PATH: '/course/learn/:courseId/lecture/:lectureId',
    NAME: 'course-detail',
  },
  MAINTAIN: {
    PATH: '/maintain',
    NAME: 'maintain',
  },
}

export const RESPONSE_CODE = {
  SUCCESS: '200', // Thành công
  UN_AUTHORIZE: '401', // Hết phiên
}

export const THEME = {
  PRIMARY_COLOR: '#00B74F',
  COMPONENT_COLOR: '#00B74F',
  BORDER_RADIUS: 4,
  TOP_BAR_COLOR: '#fff',
}
export const BREAKPOINT = {
  XS: 'XS', // width < 576
  SM: 'SM', // 576 <= width < 768
  MD: 'MD', // 768 <= width < 992
  LG: 'LG', // 992 <= width < 1200
  XL: 'XL', // 1200 <= width < 1600
  XXL: 'XXL', // width >= 1600
}
export const CONTAINER_WIDTH = {
  XXL: 90,
  XL: 90,
  LG: 95,
  MD: 95,
  SM: 100,
  XS: 100,
}
export const ERROR_COLOR = 'red'
export const ERROR_TITLE = 'Thông báo'
export const SUCCESS_TITLE = 'Thông báo'
export const SUCCESS_COLOR = '#52c41a'
export const INFO_COLOR = '#0465B0'
export const INFO_TITLE = 'Thông báo'
export const WARNING_COLOR = '#faad14'
export const WARNING_TITLE = 'Cảnh báo'
export const REDIRECT_LOGO_LINK = 'https://www.vpbank.com.vn/doanh-nghiep-vua-va-nho'
export const PRODUCT_TYPE = 'LANDINGPAGE'

// ID dùng để scroll đến khi click vào menu
export const GREEN_DATA = {
  CASH_FLOW: {
    ID: 'quanlydongtien',
    IMG_LEFT: IMAGES.DIGITAL_LEFT,
    IMG_RIGHT: IMAGES.CASH_RIGHT,
    RIGHT_TEXT:
      'Tạo điều kện và cơ hội để Doanh nghiệp có môi trường xây dựng mạng lưới khách hàng và đối tác, kết nối, giao thương và đưa sản phẩm / dịch vụ ra thị trường thông qua các sự kiện do VPBank hoặc các đối tác của VPBank tổ chức.',
  },
  E_COMMERCE: {
    ID: 'thuongmaidientu',
    IMG_LEFT: IMAGES.ECOMMERCE_LEFT,
    IMG_RIGHT: IMAGES.DIGITAL_RIGHT,
    RIGHT_TEXT:
      'Giúp doanh nghiệp số hóa toàn diện quy trình kinh doanh, quản lý từ cơ sở hạ tầng, hệ thống quản trị thông tin, dữ liệu, nhân sự,… Từ đó, nâng cao năng suất, tiết kiệm thời gian, giảm tải nguồn lực để phát triển bền vững, mạnh mẽ hơn.',
  },
  FINANCE: {
    ID: 'taichinh',
    IMG_LEFT: IMAGES.FINANCE_LEFT1,
    IMG_RIGHT: IMAGES.FINANCE_RIGHT,
    RIGHT_TEXT:
      'Cung cấp gói dịch vụ tài chính giúp doanh nghiệp lựa chọn giải pháp phù hợp để áp dụng trong các giai đoạn khác nhau cũng như thích ứng với từng mô hình kinh doanh qua đó nắm bắt mọi thời cơ trong kinh doanh sản xuất.',
  },
  KNOWLEDGE: {
    ID: 'kienthuc',
    IMG_LEFT: IMAGES.KNOWLEDGE_LEFT1,
    IMG_RIGHT: IMAGES.KNOWLEDGE_RIGHT,
    RIGHT_TEXT:
      'Tặng những khóa học bổ ích và cập nhật nhất giúp doanh nghiệp củng cố thêm kỹ năng trong quản trị doanh nghiệp, nhanh chóng hội nhập với các xu hướng phát triển kinh doanh thời đại kỹ thuật số để đứng vững trên thị trường',
  },
}

// path của link đăng ký theo từng trạm
export const REGISTER_ID = {
  // CASH_FLOW: 'quanlydongtien',
  // ECOMMERCE: 'thuongmaidientu',
  // BUSINESS: 'tramkinhdoanh',
  // FINANCE: 'tramtaichinh',
  // KNOWLEDGE: 'tramkienthuc',
  CASH_FLOW: '1',
  ECOMMERCE: '2',
  FINANCE: '3',
  KNOWLEDGE: '4',
}
export const REGISTER_DETAIL_ID = {
  FINANCE_OPTIMIZE: 'toiuudongtien',
  FINANCE_INCREASE: 'giatangnguonvon',
  FINANCE_BENEFIT: 'butphadoanhso',
}
export const HEADER_FONT_SIZE_DESKTOP = '32px'
export const HEADER_FONT_SIZE_TABLET = '24px'
export const HEADER_FONT_SIZE_MOBILE = '18px'
export const TITLE_FONT_SIZE_DESKTOP = '28px'
export const TITLE_FONT_SIZE_TABLET = '20px'
export const TITLE_FONT_SIZE_MOBILE = '16px'
export const NORMAL_FONT_SIZE_DESKTOP = '18px'
export const NORMAL_FONT_SIZE_TABLET = '16px'
export const NORMAL_FONT_SIZE_MOBILE = '14px'
export const MENU_FONT_SIZE_DESKTOP = '20px'
export const MENU_FONT_SIZE_LAPTOP = '16px'
export const MENU_FONT_SIZE_TABLET = '14px'
export const MENU_FONT_SIZE_MOBILE = '12px'

export const CONTENT_PADDING_DESKTOP = '0 160px'
export const CONTENT_PADDING_LAPTOP = '0 80px'
export const CONTENT_PADDING_TABLET = '0 32px'
export const CONTENT_PADDING_MOBILE = '0 8px'
export const POS_PADDING_DESKTOP = '0 160px 0 0'
export const POS_PADDING_LAPTOP = '0 80px 0 0'
export const POS_PADDING_TABLET = '0 32px 0 0'
export const POS_PADDING_MOBILE = '0 8px 0 0'

export const MAX_LENGTH_COURSE_NAME = 50
export const COURSE_MAIN_CONTENT = 70
// endregion
export const CARE_SOLUTIONS = [
  {
    label: 'Thẻ tín dụng',
    value: 'CREDIT_CARD',
  },
  {
    label: 'Thẻ ghi nợ',
    value: 'DEBIT_CARD',
  },
  {
    label: 'Ecompay Standard',
    value: 'ES',
  },
  {
    label: 'Ecompay Platinum',
    value: 'EP',
  },
  {
    label: 'Tap to phone & POS',
    value: 'POS',
  },
]
export const TEMPLATE_CODE = 'STATION'
export const REGEX_REGISTER = {
  TAX_CODE: /^\w{10,20}$/,
  COMPANY_NAME: /^[^~'`!@#$%^*()_+={}[\]|:;"<,>?\\/\t]*$/,
  LEGAL_FULLNAME: /^[^~'`!@#$%^&*()_\-+={}[\]|:;"<,>?\\/\t]*$/,
  PHONE: /^((\+[1-9]{1,4}[ -]*)|(\\([0-9]{2,3}\\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/,
  EMAIL: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
}
export const CARE_SOLUTIONS_DIGITAL = {
  SALE_MANAGEMENT: {
    label: 'Quản trị bán hàng',
    value: 'SALE_MANAGEMENT',
  },
  FINANCE_MANAGEMENT: {
    label: 'Quản trị tài chính',
    value: 'FINANCE_MANAGEMENT',
  },
  HUMAN_RESOURCE_MANAGEMENT: {
    label: 'Quản trị nhân sự',
    value: 'HUMAN_RESOURCE_MANAGEMENT',
  },
  COMMUNICATION_MANAGEMENT: {
    label: 'Quản trị truyền thông',
    value: 'COMMUNICATION_MANAGEMENT',
  },
}
export const ATTEND_TYPES_BUSINESS = {
  ATTEND_ONLY: {
    label: 'Chỉ tham dự',
    value: 'ATTEND_ONLY',
  },
  ATTEND_AND_BOOKING: {
    label: 'Tham dự và đặt gian hàng',
    value: 'ATTEND_AND_BOOKING',
  },
}
export const ADDRESS_TYPES_BUSINESS = {
  ADDRESS_1: {
    label: 'Hà Nội',
    value: 'ADDRESS_1',
  },
  ADDRESS_2: {
    label: 'TP. Hồ Chí Minh',
    value: 'ADDRESS_2',
  },
}
export const CARE_SOLUTIONS_FINANCE_1 = {
  CAPITAL: {
    label: 'Nguồn vốn',
    value: 'CAPITAL',
  },
  MONEY_FLOW: {
    label: 'Quản lý dòng tiền',
    value: 'MONEY_FLOW',
  },
  LC: {
    label: 'Tài trợ thương mại',
    value: 'LC',
  },
  PAYMENT: {
    label: 'Thanh toán',
    value: 'PAYMENT',
  },
  LOAN: {
    label: 'Tiền gửi',
    value: 'LOAN',
  },
  SALE_MANAGEMENT: {
    label: 'Quản trị bán hàng',
    value: 'SALE_MANAGEMENT',
  },
  FINANCE_MANAGEMENT: {
    label: 'Quản trị tài chính',
    value: 'FINANCE_MANAGEMENT',
  },
  HUMAN_RESOURCE_MANAGEMENT: {
    label: 'Quản trị nhân lực',
    value: 'HUMAN_RESOURCE_MANAGEMENT',
  },
  COMMUNICATION_MANAGEMENT: {
    label: 'Quản trị truyền thông',
    value: 'COMMUNICATION_MANAGEMENT',
  },
}
export const CARE_SOLUTIONS_FINANCE_2 = {
  CAPITAL: {
    label: 'Nguồn vốn',
    value: 'CAPITAL',
  },
  MONEY_FLOW: {
    label: 'Quản lý dòng tiền',
    value: 'MONEY_FLOW',
  },
  LC: {
    label: 'Tài trợ thương mại',
    value: 'LC',
  },
  PAYMENT: {
    label: 'Thanh toán',
    value: 'PAYMENT',
  },
  LOAN: {
    label: 'Tiền gửi',
    value: 'LOAN',
  },
  SALE_MANAGEMENT: {
    label: 'Quản trị bán hàng',
    value: 'SALE_MANAGEMENT',
  },
  FINANCE_MANAGEMENT: {
    label: 'Quản trị tài chính',
    value: 'FINANCE_MANAGEMENT',
  },
  HUMAN_RESOURCE_MANAGEMENT: {
    label: 'Quản trị nhân lực',
    value: 'HUMAN_RESOURCE_MANAGEMENT',
  },
  COMMUNICATION_MANAGEMENT: {
    label: 'Quản trị truyền thông',
    value: 'COMMUNICATION_MANAGEMENT',
  },
}
export const CARE_SOLUTIONS_FINANCE_3 = {
  CAPITAL: {
    label: 'Nguồn vốn',
    value: 'CAPITAL',
  },
  MONEY_FLOW: {
    label: 'Quản lý dòng tiền',
    value: 'MONEY_FLOW',
  },
  LC: {
    label: 'Tài trợ thương mại',
    value: 'LC',
  },
  PAYMENT: {
    label: 'Thanh toán',
    value: 'PAYMENT',
  },
  LOAN: {
    label: 'Tiền gửi',
    value: 'LOAN',
  },
  SALE_MANAGEMENT: {
    label: 'Quản trị bán hàng',
    value: 'SALE_MANAGEMENT',
  },
  FINANCE_MANAGEMENT: {
    label: 'Quản trị tài chính',
    value: 'FINANCE_MANAGEMENT',
  },
  HUMAN_RESOURCE_MANAGEMENT: {
    label: 'Quản trị nhân lực',
    value: 'HUMAN_RESOURCE_MANAGEMENT',
  },
  COMMUNICATION_MANAGEMENT: {
    label: 'Quản trị truyền thông',
    value: 'COMMUNICATION_MANAGEMENT',
  },
}
export const STATION_CONFIG_TYPE = {
  REAL: 'APPROVED',
  WAITING_FOR_APPROVE: 'WAITING_FOR_APPROVE',
  DRAFT: 'DRAFT',
}
export const STATION_TYPE = {
  BUSINESS: 'BUSINESS',
  ECOMMERCE: 'ECOMMERCE',
  FINANCE: 'FINANCE',
  KNOWLEDGE: 'KNOWLEDGE',
}
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY